import axiosInstance from "./axios";
import { errorToast } from "../shared/Toast";

/**
 * /api/media — the merchant's image library. Reads fall back to an empty list; writes return null
 * on failure after a toast.
 */

export const MEDIA_LIMITS = {
  imageBytes: 5 * 1024 * 1024,
  imageMimeTypes: ["image/jpeg", "image/png", "image/webp"],
  perUpload: 5,
  title: 120,
};

const EMPTY_LIST = { items: [], total: 0, page: 1, limit: 24, totalPages: 0 };

const messageOf = (error, fallback) => error?.response?.data?.message ?? error?.message ?? fallback;

const read = async (call, fallback, message) => {
  try {
    const res = await call();
    if (res?.data && !res.data.isError) return res.data.data ?? fallback;
    errorToast(res?.data?.message ?? message);
    return fallback;
  } catch (error) {
    errorToast(messageOf(error, message));
    return fallback;
  }
};

const write = async (call, message) => {
  try {
    const res = await call();
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? message);
    return null;
  } catch (error) {
    errorToast(messageOf(error, message));
    return null;
  }
};

export const listMedia = (params = {}) =>
  read(() => axiosInstance.get("/api/media", { params }), EMPTY_LIST, "Error loading images");

/** dataType must precede the files: the server's multer picks the folder while the fields stream. */
export const uploadMedia = (merchantId, files) => {
  const form = new FormData();
  form.append("dataType", "media");
  form.append("merchantId", merchantId);
  files.forEach((file) => form.append("images", file));
  return write(() => axiosInstance.post("/api/media", form, { rawRequest: true }), "Error uploading images");
};

export const renameMedia = (id, title) =>
  write(() => axiosInstance.patch(`/api/media/${id}`, { title }), "Error renaming image");

export const deleteMedia = (id) =>
  write(() => axiosInstance.delete(`/api/media/${id}`), "Error deleting image");
